import React from "react";
import "./PagesCss/Contato.css";
import BotaoWhatsapp from "../component/BotaoWhatsapp";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "bootstrap";
import ContatoComponent from "../component/ContatoComponent";

function Contato() {
  return (
    <section id="contact">
      <h2 className="headline">Contato</h2>
      <div className="">
        <br />
        <br />
        <br />
        <br />
        <br />
        <ContatoComponent />
      </div>

      <div className="loc-card">
        <div className="">
          <h1>Novo Horizonte</h1>
          <p>
            Rua Trajano Machado, 595
            <br />
            Centro CEP: 14960-064 - Novo Horizonte - SP - Brasil
          </p>
          <p>
            <strong>WhatsApp:</strong> (11) 9 9456-1403
            <br />
          </p>
          <p>
            <strong>E-mail:</strong> contato@custodioquessadalima.com
            <br />
          </p>
          <p className="link"></p>
          <a
            href="https://maps.app.goo.gl/5PAv1h5BnPT2BfwG9"
            target="_blank"
            rel="noopener noreferrer"
          >
            Mapa de localização
          </a>
        </div>
        <div className="">
          <iframe
            title="google-maps"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3713.003062069972!2d-49.22211382587545!3d-21.468396488050647!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94be8e0dc7627061%3A0x5da7c2c63faa8979!2sR.%20Trajano%20Machado%2C%20595%20-%20centro%2C%20Novo%20Horizonte%20-%20SP%2C%2014960-060!5e0!3m2!1spt-BR!2sbr!4v1728600023547!5m2!1spt-BR!2sbr"
            id="map"
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>

      <BotaoWhatsapp />
    </section>
  );
}

export default Contato;
